import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuthStore } from '../stores/useAuthStore';

export default function DiscordCallback() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const completeDiscordSignIn = useAuthStore(state => state.completeDiscordSignIn);
  const [error, setError] = useState<string | null>(null);
  const handled = useRef(false);

  useEffect(() => {
    // Guard against React StrictMode double-invocation — the code is single-use.
    if (handled.current) return;
    handled.current = true;

    const code = params.get('code');
    const state = params.get('state');
    const expectedState = sessionStorage.getItem('discord_oauth_state');
    sessionStorage.removeItem('discord_oauth_state');

    if (params.get('error')) {
      setError('Discord sign-in was cancelled.');
      return;
    }
    if (!code) {
      setError('Missing authorization code from Discord.');
      return;
    }
    if (!state || state !== expectedState) {
      setError('Sign-in could not be verified. Please try again.');
      return;
    }

    completeDiscordSignIn(code)
      .then(() => navigate('/', { replace: true }))
      .catch((e) => setError((e as Error).message || 'Discord sign-in failed.'));
  }, [params, completeDiscordSignIn, navigate]);

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center gap-4">
      {error ? (
        <>
          <p className="text-red-400">{error}</p>
          <button
            onClick={() => navigate('/', { replace: true })}
            className="px-4 py-2 bg-white/5 rounded-lg hover:bg-white/10 transition"
          >
            Back to home
          </button>
        </>
      ) : (
        <>
          <Loader2 className="w-10 h-10 text-pink-500 animate-spin" />
          <p className="text-gray-300">Completing Discord sign-in…</p>
        </>
      )}
    </div>
  );
}
